import type { Tab } from '../../custom-tab-bar/type.d.ts';

export const route = {
  component: () => import('./page.vue'),
  path: '/devices',
  name: 'devices',
  meta: {
    title: '设备',
    auth: true,
    wechat: {
      openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp'],
    },
  },
};

export const tab: Tab = {
  label: route.meta.title,
  icon: 'cluster-o',
  to: {
    name: route.name,
  },
};
